module.exports = __webpack_public_path__ + "img/new_index_customer_bg.a958ea02.jpg";